import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePicture,  ImageSelectorPipe, ImageWidthPipe, ImageHeightPipe, PeopleImagePipe } from "../";
import { LazySrcDirective } from "../lazy/lazy-src.directive";
import { LazyBackgroundSrcDirective } from "../lazy/lazy-background-src.directive";
import { LazyViewport } from "../lazy/lazy-viewport";
import { LazyViewportDirective } from "../lazy/lazy-viewport.directive";

@NgModule({
    declarations: [
        ImagePicture, //Pipes
        ImageWidthPipe,
        ImageHeightPipe,
		ImageSelectorPipe,
		PeopleImagePipe,
		LazySrcDirective,
		LazyBackgroundSrcDirective,
		LazyViewportDirective
    ],
    imports: [ CommonModule ],
    exports: [
        ImagePicture, //Pipes
        ImageWidthPipe,
        ImageHeightPipe,
		ImageSelectorPipe,
		PeopleImagePipe,
		LazySrcDirective,
		LazyBackgroundSrcDirective,
		LazyViewportDirective
    ],
    providers: [
		// Setup the default LazyViewport instance without an associated element. This
		// will create a IntersectionObserver that uses the browser's viewport as the
		// observer root. This way, an instance of LazyViewport is always available for
		// injection into other directives and services.
		// --
		// NOTE: This service will be overridden at lower-levels in the component tree
		// whenever a [lazyViewport] directive is applied.
		{
			provide: LazyViewport,
			useFactory: function() {

				var viewport = new LazyViewport();
				viewport.setup( /* No root. */ );

				return( viewport );

			}
		}
	]
})

export class ImagesModule {
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/custom-image/module/image-module.ts